import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router';
import { VendorInfoSection } from '../vendor-info-section';
import { useVendorDetailsStore } from '../store';
import {
    VendorContext,
    VendorActionsContext
} from '@src/vouchers/vendor-details';
import { ProductState } from '@api/WalletClient';

export const VendorDetailsTab = observer(() => {
    const { vendorId } = useParams();
    const { updateVendorState } = useVendorDetailsStore();

    const vendorData = React.useContext(VendorContext);
    const { reloadVendor } = React.useContext(VendorActionsContext);

    if (!vendorData) {
        return null;
    }

    const handleStateToggle = async (state: ProductState) => {
        await updateVendorState.request([Number(vendorId), state]);
        await reloadVendor();
    };

    return (
        <VendorInfoSection
            vendor={vendorData}
            onToggleState={handleStateToggle}
            loading={updateVendorState.loading}
            onImageUpdate={reloadVendor}
        />
    );
});
